import * as mockData from '../data/mock';

// 收藏数据
let favorites = { products: [], showcases: [] };
// 浏览历史
let browsingHistory = [];

// 初始化数据
export const initializeData = () => {
  console.log('数据已初始化');
  return Promise.resolve();
};

// 获取所有商品
export const getProducts = () => {
  return Promise.resolve(mockData.products || []);
};

// 获取所有水晶类型
export const getCrystalTypes = () => {
  return Promise.resolve(mockData.crystalTypes || []);
};

// 获取所有首饰类别
export const getJewelryCategories = () => {
  return Promise.resolve(mockData.jewelryCategories || []);
};

// 获取所有晒单
export const getShowcases = () => {
  return Promise.resolve(mockData.showcases || []);
};

// 获取商品详情
export const getProductById = (id) => {
  console.log('查找商品ID:', id);
  console.log('可用商品:', mockData.products);
  
  if (!mockData.products || !Array.isArray(mockData.products)) {
    console.error('商品数据不可用');
    return Promise.resolve(null);
  }
  
  const product = mockData.products.find(p => p.id === parseInt(id));
  console.log('找到的商品:', product);
  return Promise.resolve(product || null);
};

// 搜索商品
export const searchProducts = (query) => {
  if (!query) return Promise.resolve([]);
  
  const lowercasedQuery = query.toLowerCase();
  const results = mockData.products.filter(product => 
    product.name.toLowerCase().includes(lowercasedQuery) ||
    product.description.toLowerCase().includes(lowercasedQuery) ||
    product.crystalType.toLowerCase().includes(lowercasedQuery)
  );
  
  return Promise.resolve(results);
};

// 获取相关商品
export const getRelatedProducts = (productId) => {
  const product = mockData.products.find(p => p.id === parseInt(productId));
  if (!product) return Promise.resolve([]);
  
  const related = mockData.products
    .filter(p => p.crystalTypeId === product.crystalTypeId && p.id !== product.id)
    .slice(0, 4);
  
  return Promise.resolve(related);
};


// 添加到浏览历史
export const addToBrowsingHistory = (productId) => {
  // 如果已存在，先移除
  browsingHistory = browsingHistory.filter(id => id !== productId);
  
  // 添加到开头
  browsingHistory.unshift(productId);
  
  // 限制最多保存20条
  if (browsingHistory.length > 20) {
    browsingHistory = browsingHistory.slice(0, 20);
  }
  
  return Promise.resolve(browsingHistory);
};

// 获取浏览历史
export const getBrowsingHistory = () => {
  return Promise.resolve(browsingHistory);
};

// 切换商品收藏状态
export const toggleFavoriteProduct = (productId) => {
  const index = favorites.products.indexOf(productId);
  
  if (index === -1) {
    favorites.products.push(productId);
  } else {
    favorites.products.splice(index, 1);
  }
  
  return Promise.resolve(favorites);
};

// 切换晒单收藏状态
export const toggleFavoriteShowcase = (showcaseId) => {
  const index = favorites.showcases.indexOf(showcaseId);
  
  if (index === -1) {
    favorites.showcases.push(showcaseId);
  } else {
    favorites.showcases.splice(index, 1);
  }
  
  return Promise.resolve(favorites);
};

// 获取收藏
export const getFavorites = () => {
  return Promise.resolve(favorites);
};

// 添加到搜索历史
export const addToSearchHistory = (query) => {
  // 简单模拟，实际应用中应该保存到本地存储
  console.log('添加到搜索历史:', query);
  return Promise.resolve();
};

// 计算五行能量
export const calculateElementEnergy = (birthdate, name) => {
  // 简单模拟五行能量计算
  const elements = ['金', '木', '水', '火', '土'];
  const energyValues = {};
  
  // 基于生日计算基础能量
  const birthSum = birthdate.split('-').reduce((sum, part) => sum + parseInt(part), 0);
  
  elements.forEach((element, index) => {
    // 模拟计算，实际应用中应该有更复杂的算法
    let value = ((birthSum + index) % 50) + 50;
    
    // 名字影响
    if (name) {
      const nameValue = name.length * (index + 1);
      value = (value + nameValue) % 100;
    }
    
    energyValues[element] = value;
  });
  
  // 创建符合EnergyCharts组件期望的数据格式
  const result = {
    elements: {
      birth: {
        month: elements[birthSum % 5],
        day: elements[(birthSum + 2) % 5]
      },
      name: {
        first: elements[name.length % 5],
        middle: elements[(name.length + 2) % 5],
        last: elements[(name.length + 4) % 5]
      }
    },
    energy: {
      emotion: Math.floor(Math.random() * 40) + 60, // 情感能量
      career: Math.floor(Math.random() * 40) + 60,  // 事业能量
      health: Math.floor(Math.random() * 40) + 60,  // 健康能量
      wealth: Math.floor(Math.random() * 40) + 60   // 财富能量
    },
    recommendations: [
      {
        name: elements[birthSum % 5],
        reason: `您的${elements[birthSum % 5]}元素能量较弱，建议佩戴${elements[birthSum % 5]}属性的水晶来增强平衡。`
      },
      {
        name: elements[(birthSum + 2) % 5],
        reason: `增强${elements[(birthSum + 2) % 5]}元素能量有助于提升您的整体运势。`
      }
    ]
  };
  
  return Promise.resolve(result);
};

// 获取星座水晶
export const getZodiacCrystals = (zodiacSign) => {
  const zodiac = mockData.zodiacData.find(z => z.name === zodiacSign);
  return Promise.resolve(zodiac ? zodiac.crystals : []);
};

// 获取水晶推荐
export const getCrystalRecommendations = (elementEnergy) => {
  // 基于五行能量推荐水晶
  const recommendations = [];
  
  // 找出最弱的两个元素
  const sortedElements = Object.entries(elementEnergy)
    .sort(([, valueA], [, valueB]) => valueA - valueB)
    .slice(0, 2)
    .map(([element]) => element);
  
  // 为每个弱势元素推荐水晶
  sortedElements.forEach(element => {
    let crystalType;
    
    switch (element) {
      case '金':
        crystalType = mockData.crystalTypes.find(t => t.name === '黄水晶');
        break;
      case '木':
        crystalType = mockData.crystalTypes.find(t => t.name === '绿幽灵');
        break;
      case '水':
        crystalType = mockData.crystalTypes.find(t => t.name === '蓝晶');
        break;
      case '火':
        crystalType = mockData.crystalTypes.find(t => t.name === '红玛瑙');
        break;
      case '土':
        crystalType = mockData.crystalTypes.find(t => t.name === '黑曜石');
        break;
      default:
        crystalType = mockData.crystalTypes[0];
    }
    
    if (crystalType) {
      // 找出该类型的商品
      const products = mockData.products
        .filter(p => p.crystalTypeId === crystalType.id)
        .slice(0, 2);
      
      recommendations.push({
        element,
        crystalType,
        products
      });
    }
  });
  
  return Promise.resolve(recommendations);
};